<template>
  <v-container :id="`helptext-container-${fieldConfig.identifier}`" class="d-flex" style="position: relative">
    <component
      :is="fieldConfig.component"
      :key="fieldConfig.identifier"
      ref="component"
      v-model="formData[fieldConfig.identifier]"
      :class="fieldConfig.class"
      :clearable="fieldConfig.clearable"
      :disabled="fieldConfig.disabled"
      :items="fieldConfig.items"
      :multiple="fieldConfig.multiple"
      :name="fieldConfig.identifier"
      :label="label"
      :placeholder="placeholder"
      :rules="rules"
      :return-object="fieldConfig.returnObject"
    />
    <v-tooltip
      v-if="helpText"
      v-model="show"
      :attach="`#helptext-container-${fieldConfig.identifier}`"
      content-class="helptext-tooltip"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          style="position: absolute; right: 1em; top: 2.5em"
          small
          icon
          v-bind="attrs"
          :v-on="on"
          :color="show ? 'primary' : ''"
          @click.stop="show = !show"
        >
          <v-icon small>mdi-information</v-icon>
        </v-btn>
      </template>
      <span style="white-space: pre-wrap">{{ helpText }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { VAutocomplete, VCheckbox, VCombobox, VSelect, VTextarea, VTextField } from 'vuetify/lib/components'

export default {
  name: 'CustomInput',
  components: {
    VAutocomplete,
    VCheckbox,
    VCombobox,
    VSelect,
    VTextarea,
    VTextField,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    possibleFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    default() {
      if (this.field.default_value !== null) {
        return this.field.default_value
      }
      return this.fieldConfig.default
    },
    fieldConfig() {
      return this.possibleFields[this.field.identifier]
    },
    helpText() {
      return this.field.help_text
    },
    label() {
      return this.field.label || this.fieldConfig.label
    },
    placeholder() {
      return this.field.placeholder
    },
    rules() {
      const required = this.field.required || this.fieldConfig.required
      if (required) {
        return [this.$rules.required]
      }
      return []
    },
  },
  watch: {
    'field.identifier': {
      immediate: true,
      handler() {
        this.setDefault()
      },
    },
    default() {
      this.setDefault()
    },
  },
  methods: {
    setDefault() {
      const key = this.fieldConfig?.identifier
      if (!key) return

      const current = this.formData[key]
      const isUnset = current === undefined || current === null || current === ''

      if (isUnset && this.default !== undefined) {
        this.$set(this.formData, key, this.default)
      }
    },
  },
}
</script>

<style scoped>
.helptext-tooltip {
  position: absolute;
  top: 25px !important;
  right: 40px;
  left: unset !important;
  max-width: min(calc(100% - 40px), 400px);
}
</style>
